var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.334 4.667V3a1.667 1.667 0 0 0-1.667-1.667H3A1.667 1.667 0 0 0 1.333 3v6.667A1.667 1.667 0 0 0 3 11.333h1.667m1.667-6.666H13c.92 0 1.667.746 1.667 1.666V13c0 .92-.746 1.667-1.667 1.667H6.333c-.92 0-1.666-.747-1.666-1.667V6.333c0-.92.746-1.666 1.667-1.666Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgCopy;